import { render, staticRenderFns } from "./PartnerOrderInvcs.vue?vue&type=template&id=240c5ad0&"
import script from "./PartnerOrderInvcs.vue?vue&type=script&lang=js&"
export * from "./PartnerOrderInvcs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports